import React from 'react'
import PropTypes from 'prop-types'

import {
  tresholdForDisplay,
  bloodPressureTresholdForDisplay,
} from '@util/tresholdUtil'
import colors from '@settings/styleSettings'
import Text from './Text'

export const TresholdDisplay = ({
  syst, diast, value, type
}) => (
  <div style={{ color: colors.strongGray, margin: 0 }}>
    {type === 'bloodPressure'
      ? bloodPressureTresholdForDisplay(syst, diast, Text)
      : tresholdForDisplay(type, value, Text)}
  </div>
)

TresholdDisplay.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  syst: PropTypes.number.isRequired,
  diast: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
}

TresholdDisplay.defaultProps = {
  value: null,
}
